import {
  CHAKRA_SELECT_TYPE,
  ChakraSelectChildData,
  ChakraSelectChildrenCategory,
  ChakraSelectParentData,
  ChakraSelectParentsCategory,
  ChakraSelectSelected,
  ChakraSelectSubChildData,
  ChakraSelectSubChildrenCategory,
} from '../../components/common/ChakraSelect/ChakraSelect';
import { ObjectsParams } from '../../types/ParamsTypes';
import { AxiosResponse } from 'axios';
import { getAxiosWithConfig } from '../Http/HttpService';
import { ExtendedDetailsRoute, ExtendedDetailsRouteObjects } from '../../types/RoutesTypes';
import {
  ObjectsCities,
  ObjectsCountries,
  ObjectsLocations,
  ObjectsRegions,
  ObjectsResponse,
} from '../../types/ObjectsTypes';

export const fetchAllObjects = async (
  objectsParams: ObjectsParams,
): Promise<AxiosResponse<ObjectsResponse>> => {
  try {
    const instance = getAxiosWithConfig();

    return instance.post('plugin', {
      plugin: 'booking',
      data: {
        module: 'objectsData',
        params: objectsParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};


export const getChakraSelectCountriesData = (
  countries: ObjectsCountries,
): ChakraSelectParentsCategory => {
  const data: ChakraSelectParentData[] = countries.countries.map(country => {
    return { id: country.uniqueId, name: country.Title };
  });

  return {
    selectable: false,
    data,
  };
};

export const getChakraSelectRegionsData = (
  regions: ObjectsRegions,
): ChakraSelectChildrenCategory => {
  const data: ChakraSelectChildData[] = regions.regions.map(region => {
    return { id: region.uniqueId, name: region.Title, parent: region.Country };
  });

  return {
    selectable: true,
    data,
  };
};

export const getChakraSelectCitiesData = (
  cities: ObjectsCities,
): ChakraSelectSubChildrenCategory => {
  const data: ChakraSelectSubChildData[] = cities.cities.map(city => {
    return { id: city.uniqueId, name: city.Title, child: city.Region };
  });

  return {
    selectable: true,
    data,
  };
};

export const getDefaultObjectsParams = (): ObjectsParams => {
  return {
    cities: [],
    regions: [],
    features: [],
    numberOfAdults: 2,
    numberOfChildren: 0,
    numberOfPets: 0,
    agesOfChildren: [],
    numberOfBedrooms: 0,
  };
};

export const getChakraSelectLocationSelected = (
  objectsParams: ObjectsParams,
  locations: ObjectsLocations,
): ChakraSelectSelected | undefined => {
  if (objectsParams.cities?.length > 0) {
    const city = locations.cities.cities.find(city => city.uniqueId === objectsParams.cities[0]);
    if (city) {
      return { id: city.uniqueId, name: city.Title, type: CHAKRA_SELECT_TYPE.SUB_CHILD };
    }
  }

  if (objectsParams.regions?.length > 0) {
    const region = locations.regions.regions.find(
      region => region.uniqueId === objectsParams.regions[0],
    );
    if (region) {
      return { id: region.uniqueId, name: region.Title, type: CHAKRA_SELECT_TYPE.CHILD };
    }
  }
  return undefined;
};

export const getUpdatedObjectFilterLocationParams = (
  type: CHAKRA_SELECT_TYPE,
  id: string,
): { cities: Array<string>; regions: Array<string> } => {
  const objectFilterLocationParams: { cities: Array<string>; regions: Array<string> } = {
    cities: [],
    regions: [],
  };

  if (type === CHAKRA_SELECT_TYPE.CHILD) {
    objectFilterLocationParams.regions.push(id);
  }

  if (type === CHAKRA_SELECT_TYPE.SUB_CHILD) {
    objectFilterLocationParams.cities.push(id);
  }

  return objectFilterLocationParams;
};

export const getObjectFilterParamsWithoutEmptyProperties = (objectsParams: any): ObjectsParams => {
  const objectsParamsWithValues = { ...objectsParams };
  Object.keys(objectsParamsWithValues).forEach(k => {
    if (typeof objectsParamsWithValues[k] === 'number' && objectsParamsWithValues[k] === 0) {
      delete objectsParamsWithValues[k];
    }

    if (typeof objectsParamsWithValues[k] === 'object' && objectsParamsWithValues[k].length === 0) {
      delete objectsParamsWithValues[k];
    }

    if (typeof objectsParamsWithValues[k] === 'string' && objectsParamsWithValues[k].length === 0) {
      delete objectsParamsWithValues[k];
    }
  });
  return objectsParamsWithValues;
};

export const getArrayObjectsRouteParam = (type: string, objectsParam?: string) => {
  let objectsParamArray: any = [];
  if (objectsParam) {
    const isParamNull = objectsParam === `no_${type}`;
    if (isParamNull) {
      objectsParamArray = [];
    } else {
      objectsParamArray = objectsParam.split(',');
      type === 'ages' ? objectsParamArray = (objectsParamArray.map(Number)) : (objectsParamArray.map(String));
    }
  }
  return objectsParamArray;
};

export const getInitialObjectsParamas = (routeParams: ExtendedDetailsRouteObjects) => {
  let agesOfChildren = getArrayObjectsRouteParam('ages', routeParams?.agesOfChildren);
  let regions = getArrayObjectsRouteParam('regions', routeParams?.regions);
  let cities = getArrayObjectsRouteParam('cities', routeParams?.cities);
  let features = getArrayObjectsRouteParam('features', routeParams?.features);

  return {
    fromDate: routeParams.fromDate ? routeParams.fromDate : '',
    toDate: routeParams.toDate ? routeParams.toDate : '',
    numberOfAdults: routeParams.numberOfAdults ? Number.parseInt(routeParams.numberOfAdults) : 2,
    numberOfChildren: routeParams.numberOfChildren
      ? Number.parseInt(routeParams.numberOfChildren)
      : 0,
    agesOfChildren: agesOfChildren,
    numberOfPets: routeParams.numberOfPets ? +routeParams.numberOfPets : 0,
    numberOfBedrooms: routeParams.numberOfBedrooms ? +routeParams.numberOfBedrooms : 0,
    regions: regions,
    cities: cities,
    features: features,
  };
};